var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "terms-of-service" }, [
      _c("h1", [_vm._v("Terms of Service for VibeTap")]),
      _c("p", [
        _c("strong", [_vm._v("Effective Date:")]),
        _vm._v(" November 3, 2024"),
      ]),
      _c("p", [
        _vm._v(
          "Welcome to VibeTap! By accessing or using our website, you agree to comply with and be bound by the following Terms of Service. Please read these terms carefully."
        ),
      ]),
      _c("h2", [_vm._v("1. Acceptance of Terms")]),
      _c("p", [
        _vm._v(
          "By accessing and using the services provided by VibeTap, you agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree with any part of these terms, please discontinue using our site."
        ),
      ]),
      _c("h2", [_vm._v("2. Use of the Site")]),
      _c("p", [
        _vm._v(
          "You may use the site for lawful purposes only. You agree not to engage in any activities that could harm, disrupt, or limit the functionality of our website or infringe on the rights of other users."
        ),
      ]),
      _c("h2", [_vm._v("3. Account Registration and Security")]),
      _c("p", [
        _vm._v(
          "When creating an account with VibeTap, you agree to provide accurate and complete information. You are responsible for maintaining the security of your account and for all activities conducted under your account. VibeTap reserves the right to suspend or terminate accounts that violate these terms."
        ),
      ]),
      _c("h2", [_vm._v("4. Payments and Subscriptions")]),
      _c("p", [
        _vm._v("We use "),
        _c("strong", [_vm._v("Stripe")]),
        _vm._v(
          " to process all payments securely. By providing payment information, you agree to be bound by Stripe’s terms and conditions. VibeTap does not store sensitive payment details on its servers, as Stripe handles all payment data directly. For more information on how Stripe processes data, please refer to "
        ),
        _c(
          "a",
          { attrs: { href: "https://stripe.com/privacy", target: "_blank" } },
          [_vm._v("Stripe’s Privacy Policy")]
        ),
        _vm._v("."),
      ]),
      _c("h2", [_vm._v("5. Alcohol Sales and Underage Drinking")]),
      _c("p", [
        _vm._v(
          "VibeTap provides tools for venues to manage menus and orders, but it is the sole responsibility of the venue to comply with local laws regarding the sale and service of alcohol. This includes verifying the age of patrons and refusing service to underage individuals. VibeTap holds no responsibility for underage drinking or any consequences arising from a venue’s failure to comply with these regulations."
        ),
      ]),
      _c("p", [
        _vm._v(
          "Venues must ensure that any orders placed by minors are canceled promptly and take necessary steps to prevent unauthorized purchases of alcoholic beverages."
        ),
      ]),
      _c("h2", [_vm._v("6. Intellectual Property")]),
      _c("p", [
        _vm._v(
          "All content on this website, including text, graphics, logos, and software, is the property of VibeTap or its content suppliers and is protected by copyright, trademark, and other intellectual property laws. Unauthorized use or reproduction of our content is prohibited."
        ),
      ]),
      _c("h2", [_vm._v("7. User Content and Conduct")]),
      _c("p", [
        _vm._v(
          "You may post content on our site, but you agree not to post any content that:"
        ),
      ]),
      _c("ul", [
        _c("li", [_vm._v("Violates any applicable law or regulation.")]),
        _c("li", [
          _vm._v("Is harmful, offensive, or infringes on others’ rights."),
        ]),
        _c("li", [_vm._v("Contains viruses or any other harmful components.")]),
      ]),
      _c("p", [
        _vm._v(
          "VibeTap reserves the right to remove or modify content that violates these terms."
        ),
      ]),
      _c("h2", [_vm._v("8. Account Termination")]),
      _c("p", [
        _vm._v(
          "You may delete your account and all personal information stored by us at any time by contacting us at "
        ),
        _c("a", { attrs: { href: "mailto:help@vibe-tap.com" } }, [
          _vm._v("help@vibe-tap.com"),
        ]),
        _vm._v(
          ". Upon account deletion, you will no longer have access to services associated with your account."
        ),
      ]),
      _c("h2", [_vm._v("9. Limitation of Liability")]),
      _c("p", [
        _vm._v(
          "VibeTap shall not be liable for any indirect, incidental, special, or consequential damages resulting from the use or inability to use our services, including but not limited to damages for lost profits, data, or other intangible losses."
        ),
      ]),
      _c("h2", [_vm._v("10. Indemnification")]),
      _c("p", [
        _vm._v(
          "You agree to indemnify and hold harmless VibeTap, its affiliates, and employees from any claim or demand, including reasonable attorney’s fees, arising out of your use of our site, your violation of these terms, or infringement of any rights of another person or entity."
        ),
      ]),
      _c("h2", [_vm._v("11. Changes to Terms")]),
      _c("p", [
        _vm._v(
          'VibeTap reserves the right to modify these Terms of Service at any time. We will notify you of any material changes by updating the "Effective Date" above. Continued use of our site after such changes indicates your acceptance of the new terms.'
        ),
      ]),
      _c("h2", [_vm._v("12. Contact Us")]),
      _c("p", [
        _vm._v(
          "If you have any questions about these Terms of Service, please contact us at "
        ),
        _c("a", { attrs: { href: "mailto:help@vibe-tap.com" } }, [
          _vm._v("help@vibe-tap.com"),
        ]),
        _vm._v("."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }